import {
  WSFlexBox,
  WSGrid,
  WSList,
  WSSectionToolbar
} from "@wingspanhq/fe-component-library";
import { useQueryCards } from "../../../../query/cards/queries/useQueryCards";
import { WSQueries } from "../../../../query/WSQuery";
import { selectorWalletCards } from "../../../Wallet/selectors/selectorWalletCards";
import { WalletCardType } from "../../../Wallet/types";
import { EmbeddedWalletCardSlot } from "./EmbeddedWalletCardSlot";
import { WalletCardSkeleton } from "./WalletCardSkeleton";

export const WALLET_CARD_TITLES: Record<WalletCardType, string> = {
  virtual: "Virtual debit card",
  physical: "Physical debit card"
};

type Props = {
  allowedCardTypes: WalletCardType[];
  onOrder: (cardType: WalletCardType) => void;
  onManage: (cardId: string) => void;
};

export const WalletCardsSkeleton: React.FC<{
  allowedCardTypes: WalletCardType[];
}> = ({ allowedCardTypes }) => (
  <WalletCardsGrid allowedCardTypes={allowedCardTypes}>
    {cardType => (
      <WSList gap="XL">
        <WSSectionToolbar title={WALLET_CARD_TITLES[cardType]} />
        <WSFlexBox.Center>
          <WalletCardSkeleton />
        </WSFlexBox.Center>
      </WSList>
    )}
  </WalletCardsGrid>
);

export const EmbeddedWalletCardsLanding: React.FC<Props> = ({
  allowedCardTypes,
  onOrder,
  onManage
}) => {
  const cardsQuery = useQueryCards();

  return (
    <WSQueries
      queries={{ cardsQuery }}
      renderLoader={() => (
        <WalletCardsSkeleton allowedCardTypes={allowedCardTypes} />
      )}
    >
      {({ cardsQueryData }) => {
        const cards = selectorWalletCards(cardsQueryData);

        return (
          <WalletCardsGrid allowedCardTypes={allowedCardTypes}>
            {cardType => {
              const card = cards.find(
                card =>
                  card.isVirtualCard === (cardType === WalletCardType.Virtual)
              );

              return (
                <WSList gap="XL">
                  <WSSectionToolbar
                    title={WALLET_CARD_TITLES[cardType]}
                    button={
                      card
                        ? {
                            label: "Manage",
                            rightIcon: "chevron-right",
                            onClick: () => onManage(card.cardId)
                          }
                        : undefined
                    }
                  />
                  <WSFlexBox.Center>
                    <EmbeddedWalletCardSlot
                      cardType={cardType}
                      card={card}
                      onOrder={() => onOrder(cardType)}
                    />
                  </WSFlexBox.Center>
                </WSList>
              );
            }}
          </WalletCardsGrid>
        );
      }}
    </WSQueries>
  );
};

const WalletCardsGrid: React.FC<{
  allowedCardTypes: WalletCardType[];
  children: (cardType: WalletCardType) => React.ReactNode;
}> = ({ allowedCardTypes, children }) => (
  <WSGrid gutter="XL">
    {allowedCardTypes.length === 1 && <WSGrid.Item span={{ m: "3" }} />}
    {allowedCardTypes.map(cardType => (
      <WSGrid.Item key={cardType} span={{ s: "12", m: "6" }}>
        {children(cardType)}
      </WSGrid.Item>
    ))}
  </WSGrid>
);
